// App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';
import { DoctorProvider } from './contexts/DoctorContext';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { FeedbackProvider } from './components/EnhancedFeedbackProvider';
import { NotificationProvider } from './contexts/NotificationContext';
import medicalTheme from './theme/medicalTheme';
import Dashboard from './pages/Dashboard';
import PatientList from './pages/PatientList';
import PatientDetail from './pages/PatientDetail';
import Calendar from './pages/Calendar';
import Consultations from './pages/Consultations';
import Vitals from './pages/Vitals';
import Treatments from './pages/Treatments';
import History from './pages/History';
import Profile from './pages/Profile';
import Login from './pages/Login';
import DoctorNameInput from './components/DoctorNameInput';
import AppInitializer from './components/AppInitializer';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  const [showDoctorInput, setShowDoctorInput] = useState(false);

  const handleEditDoctor = () => {
    setShowDoctorInput(true);
  };

  return (
    <ThemeProvider theme={medicalTheme}>
      <CssBaseline />
      <ErrorBoundary>
        <AuthProvider>
          <DoctorProvider>
            <DataProvider>
              <FeedbackProvider>
                <NotificationProvider>
                  <AppInitializer>
                    <Router>
                      <div className="App">
                        <Routes>
                          <Route path="/login" element={<Login />} />
                          <Route path="/" element={
                            <ProtectedRoute>
                              <Dashboard onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                          <Route path="/patients" element={
                            <ProtectedRoute>
                              <PatientList onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                          <Route path="/patients/new" element={
                            <ProtectedRoute>
                              <PatientList onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                          <Route path="/patients/:id" element={
                            <ProtectedRoute>
                              <PatientDetail onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                          <Route path="/calendar" element={
                            <ProtectedRoute>
                              <Calendar onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                          <Route path="/consultations" element={
                            <ProtectedRoute>
                              <Consultations onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                          <Route path="/vitals" element={
                            <ProtectedRoute>
                              <Vitals onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                          <Route path="/treatments" element={
                            <ProtectedRoute>
                              <Treatments onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                          <Route path="/history" element={
                            <ProtectedRoute>
                              <History onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                          <Route path="/profile" element={
                            <ProtectedRoute>
                              <Profile onEditDoctor={handleEditDoctor} />
                            </ProtectedRoute>
                          } />
                        </Routes>
                        
                        <DoctorNameInput 
                          open={showDoctorInput} 
                          onClose={() => setShowDoctorInput(false)} 
                        />
                      </div>
                    </Router>
                  </AppInitializer>
                </NotificationProvider>
              </FeedbackProvider>
            </DataProvider>
          </DoctorProvider>
        </AuthProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;